import { render } from "./ReihenhausStep6.vue?vue&type=template&id=12c8860c&scoped=true"
import script from "./ReihenhausStep6.vue?vue&type=script&lang=js"
export * from "./ReihenhausStep6.vue?vue&type=script&lang=js"

import "./ReihenhausStep6.vue?vue&type=style&index=0&id=12c8860c&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c8860c"]])

export default __exports__